import { Text } from "native-base";

export const formatPrice = (price, prefix = '$') => {
    if (typeof price === 'number') {
        if (price >= 0) {
            return `${prefix}${price.toLocaleString('en-US', {
                minimumFractionDigits: 2,
            })}`;
        } else {
            return `-${prefix}${(price * -1).toLocaleString('en-US', {
                minimumFractionDigits: 2,
            })}`;
        }
    }
    return '';
};

export const formatDiscount = (price, discountPrice, prefix = '$') => {
    if (typeof price === 'number' &&
        typeof discountPrice === 'number' &&
        price !== discountPrice
    ) {
        return (
            <>
                <Text textDecorationLine={'line-through'} textDecorationColor={'lightText'} color={'muted.400'}>{formatPrice(price, prefix)}</Text>
                <Text>{` ${formatPrice(discountPrice, prefix)}`}</Text>
            </>
        );
    }

    return formatPrice(price || discountPrice, prefix);
};

export const formatPoints = (points, prefix = '') => {
    if (typeof points === 'number') {
        return `${prefix}${points.toLocaleString('en-US', {
            minimumFractionDigits: 0,
        })}分`;
    }
    return '';
};

export function flatDeep(arr, d = 1) {
    if (!Array.isArray(arr)) {
        return [arr];
    }
    return d > 0
        ? arr.reduce((acc, val) => acc.concat(flatDeep(val, d - 1)), [])
        : arr.slice();
}

export const getMaxQuantityOfProduct = ({
    isUnlimitStock,
    remainStock,
    maxQtyPerTransaction,
    remainQtyPerTransaction,
}) => {
    let list = [];

    if (!isUnlimitStock && typeof remainStock === 'number') {
        list.push(remainStock);
    }

    if (typeof maxQtyPerTransaction === 'number') {
        list.push(maxQtyPerTransaction);
    }

    if (typeof remainQtyPerTransaction === 'number') {
        list.push(remainQtyPerTransaction);
    }

    return Math.min(...list);
};
